import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { UiState, RootState } from '../types';

const namespaced: boolean = true;

export const state: UiState = {
	desktopNavExpanded: false,
	mobileNavOpen: false
};

export const Ui: Module<UiState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};
export default Ui;